import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';
import  {all_information, loadingShow } from '../../../App';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import Message from '../../../utils/Message/Message';
interface IState {
  reasonData: any;
}
interface IProps {
  GridHeight?: any;
}
export class OperationReasons extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private reasonId: number = -1;
  private isAdd: boolean = true;
  private type: string = 'opreason';
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
     
      reasonData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteReasons() {
    const obj = {
      id: this.reasonId,
    };
    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getReasons(this.type);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addReasons(objCommer: any) {
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      description: objCommer.description,
      reason_name: objCommer.reason_name,
      id: objCommer.id,
      type: this.type,
    };

    if (this.isAdd) {
      delete obj.id;
      AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getReasons(this.type);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getReasons(this.type);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getReasons(this.type);
  }

  getReasons(type: string) {
    getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ reasonData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getReasons(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addReasons(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addReasons(args.data);
    } else if (args.requestType === 'delete') {
      this.reasonId = args.data[0].id;
      this.deleteReasons();
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridShiftworkbenchReasons'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.reasonData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          actionBegin={this.actionBegin.bind(this)}
          showColumnMenu={true}
          allowExcelExport
          allowResizing={true}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='reason_name'
              headerText='Reason Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default OperationReasons;
